<template>
  <a-card :bordered="false">
    <div>
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="优惠券号">
                <a-input v-model="queryParam.couponscode" placeholder />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="优惠券名">
                <a-input v-model="queryParam.couponame" placeholder />
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="使用状态">
                  <a-select :getPopupContainer="trigger => trigger.parentNode" v-model="queryParam.isused" placeholder>
                    <a-select-option value="0">未使用</a-select-option>
                    <a-select-option value="1">已使用</a-select-option>
                    <a-select-option value="2">已过期</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="车牌号码">
                  <a-input v-model="queryParam.licenseplate" placeholder />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="创建时间">
                  <div>
                    <a-range-picker @change="onCreatedateChange" style=" width: 100%; " />
                  </div>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                <a-button style="margin-left: 8px" @click="handleGoBack">返回</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operator">
        <a-button type="primary" icon="plus" @click="handleAdd()">添加</a-button>
        <a-button type="primary" icon="qrcode" @click="MakeQR">优惠券二维码</a-button>
        <a-modal title="优惠券二维码--免时" :visible="QRModalVisible" @cancel="cancelMakeQR" :footer="null" :maskClosable="false">
          <a-form>
            <a-form-item label="账户余额" :labelCol="{lg: {span: 7}, sm: {span: 7}}" :wrapperCol="{lg: {span: 10}, sm: {span: 17} }">
              <span>{{surplusmoney}}￥</span>
            </a-form-item>
            <a-form-item label="优惠券" :labelCol="{lg: {span: 7}, sm: {span: 7}}" :wrapperCol="{lg: {span: 10}, sm: {span: 17} }">
              <a-select :getPopupContainer="trigger => trigger.parentNode" @change="handleSelectChange" 
              v-decorator="['SelectCoupon',{rules: [{ required: true, message: '请选择优惠券' }]}]" placeholder="请选择优惠券">
                <a-select-option v-for="(item, index) in couponList" :key="index" :value="item.u_couponsetting_id">{{item.couponame}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="二维码生成" :labelCol="{lg: {span: 7}, sm: {span: 7}}" :wrapperCol="{lg: {span: 10}, sm: {span: 17} }">
              <a-switch :disabled="switchDisabled" checkedChildren="开" unCheckedChildren="关" @change="onQrMakeChange" />
            </a-form-item>
            <a-form-item label="二维码" :labelCol="{lg: {span: 7}, sm: {span: 7}}" :wrapperCol="{lg: {span: 10}, sm: {span: 17} }">
              <canvas id="QRdiv"></canvas>
            </a-form-item>
          </a-form>
        </a-modal>
      </div>
      <s-table ref="table" size="default" rowKey="u_coupons_id" :columns="columns" :data="loadData">
        <template slot="serial" slot-scope="text, record, index">{{ index + 1 }}</template>
        <template slot="licenseplate" slot-scope="text,record">
          <template v-if="record.licenseplate == null">
            <!-- <Badge status="success" text="未使用" /> -->
            <Tag color="#bbb">无牌车辆</Tag>
            <!-- <span style=" color: green; ">未使用</span> -->
          </template>
          <template v-if="record.licenseplate != null && record.licenseplate.length === 7">
            <!-- <Badge status="success" text="未使用" /> -->
            <Tag color="blue">{{record.licenseplate}}</Tag>
            <!-- <span style=" color: green; ">未使用</span> -->
          </template>
          <template v-if="record.licenseplate != null && record.licenseplate.length === 8">
            <!-- <Badge status="success" text="未使用" /> -->
            <Tag color="green">{{record.licenseplate}}</Tag>
            <!-- <span style=" color: green; ">未使用</span> -->
          </template>
        </template>
        <template slot="isused" slot-scope="text">
          <template v-if="text===0">
            <!-- <Badge status="success" text="未使用" /> -->
            <Tag color="green">未使用</Tag>
            <!-- <span style=" color: green; ">未使用</span> -->
          </template>
          <template v-if="text===1">
            <div>
              <!-- <Badge status="processing" text="已使用" /> -->
              <Tag color="#bbb">已使用</Tag>
              <!-- <span style=" color: #bbb; ">已使用</span> -->
            </div>
          </template>
          <template v-if="text===2">
            <!-- <Badge status="warning" text="已过期" /> -->
            <Tag color="red">已过期</Tag>
            <!-- <span style=" color: #faad14; ">已过期</span> -->
          </template>
          <template v-if="text===3">
            <!-- <Badge status="default" text="已冻结" /> -->
            <Tag color="#0080ff">已冻结</Tag>
            <!-- <span style=" color: #0080ff; ">已冻结</span> -->
          </template>
        </template>
        <template slot="operation" slot-scope="text, record">
          <a-button type="danger" ghost v-if="record.isused===0">
            <a-popconfirm title="确认删除?" @confirm="() => onDelete(record)">
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </a-button>
        </template>
      </s-table>
      <a-divider orientation="left">说明</a-divider>
      <h4>此优惠卷用于用户在支付本次订单时免除订单一定时间的费用（单位小时）。</h4>
    </div>
  </a-card>
</template>

<script>
  var QRCode = require('qrcode')
  require('vue-cookies')
  import moment from 'moment'
  import Badge from 'ant-design-vue/es/badge/Badge'
  import Tag from 'ant-design-vue/es/tag/Tag'
  import STable from '@/components/Table/'
  import {
    getTimeLimitedCoupons,
    getSelectCouponsList,
    getCouponQr,
    deletCoupons
  } from '@/api/SellerCoupons'
  import {
    getSellersCoupons
  } from '@/api/Main'
  import {
    getLocalTime
  } from '@/utils/util.js'
  import config from '@/config/defaultSettings.js'

  export default {
    components: {
      Badge,
      Tag,
      STable
    },
    data() {
      return {
        switchDisabled: true,
        //优惠券下拉数据
        couponList: {},
        //优惠券信息
        couponID: '',
        //账户余额
        surplusmoney: '',
        QRModalVisible: false,

        websock: null,
        baseWsUrl: config.iXiaoZha.wsUrlConfig + '/adminwebsocket/tokenId/',
        wsUrl: '',
        ws: true,

        queryParam_createdate: '',
        // 查询参数
        queryParam: {
          createdate: ''
        },
        // 高级搜索 展开/关闭
        advanced: false,
        // 表头
        columns: [{
            title: '#',
            scopedSlots: {
              customRender: 'serial'
            }
          },
          // {
          //   title: '停车场名称',
          //   dataIndex: 'parkingname'
          // },
          {
            title: '优惠券编号',
            dataIndex: 'couponscode'
          },
          {
            title: '优惠卷名称',
            dataIndex: 'couponame'
          },
          {
            title: '车牌号码',
            dataIndex: 'licenseplate',
            scopedSlots: {
              customRender: 'licenseplate'
            }
          },
          {
            title: '手机号码',
            dataIndex: 'mobile'
          },
          {
            title: '使用状态',
            dataIndex: 'isused',
            scopedSlots: {
              customRender: 'isused'
            }
          },
          {
            title: '创建时间',
            dataIndex: 'createdate',
            customRender: text => getLocalTime(text)
          },
          {
            title: '使用时间',
            dataIndex: 'usedate',
            customRender: text => getLocalTime(text)
          },
          {
            title: '过期时间',
            dataIndex: 'expirydate',
            customRender: text => getLocalTime(text)
          },
          // {
          //   title: '备注',
          //   dataIndex: 'memo'
          // },
          {
            title: '操作',
            scopedSlots: {
              customRender: 'operation'
            }
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          //this.queryParam为V-model的提交参数集合
          //需要提交的参数集合
          var paraData = {}

          if (this.queryParam_createdate != '') {
            paraData['dateStart'] = this.queryParam_createdate[0]
            paraData['dateEnd'] = this.queryParam_createdate[1]
          }

          //https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
          //Object.assign() 方法用于将所有可枚举属性的值从一个或多个源对象复制到目标对象。它将返回目标对象。
          return getTimeLimitedCoupons(Object.assign(parameter, Object.assign(paraData, this.queryParam))).then(res => {
            return res.result
          })
        }
      }
    },
    mounted() {
      getSelectCouponsList({
        couponType: '2'
      }).then(res => {
        this.couponList = res.result
      })
      getSellersCoupons('').then(res => {
        this.surplusmoney = res.result.sellerfund == 0 ? 0 : res.result.sellerfund.surplusmoney
      })
    },
    beforeDestroy() {
      this.ws = false
      if (this.websock != null) {
        this.websock.close() //离开路由之后断开websocket连接
      }
    },
    methods: {
      handleGoBack() {
        this.$emit('onGoBack')
      },
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      onCreatedateChange(date, dateString) {
        this.queryParam_createdate = dateString
      },
      handleAdd() {
        this.$emit('onAdd')
      },
      handleSelectChange(e) {
        this.couponID = e
        this.switchDisabled = false
      },
      onDelete(record) {
        deletCoupons({
          id: record.u_coupons_id
        }).then(res => {
          if (res.status === 0) {
            this.$message.success('删除成功！')
          } else {
            this.$message.error('删除失败！' + res.message)
          }
          this.$refs.table.refresh(true)
        })
      },
      MakeQR() {
        this.QRModalVisible = true
      },
      cancelMakeQR() {
        const VM = this
        this.$confirm({
          title: '确定关闭?',
          okText: '是',
          okType: 'danger',
          cancelText: '否',
          onOk() {
            return new Promise((resolve, reject) => {
              VM.QRModalVisible = false
              this.ws = false
              if (this.websock != null) {
                this.websock.close() //离开路由之后断开websocket连接
              }
            }).catch(() => console.log('Oops errors!'))
          },
          onCancel() {}
        })
      },
      onQrMakeChange(e) {
        if (e) {
          this.ws = true
          this.initWebSocket()
          getCouponQr({
            id: this.couponID
          }).then(res => {
            if (res.status === 0) {
              this.surplusmoney = res.result.surplusmoney
              QRCode.toCanvas(
                document.getElementById('QRdiv'),
                location.origin + '/j/api/QRcode/QRjump?bid=' + res.result.bid,
                error => {
                  if (error) {
                    this.$message.error('二维码加载出错！' + error)
                  }
                }
              )
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          //重置画布即可清空二维码
          var c = document.getElementById('QRdiv')
          c.height = c.height + 1
          this.ws = false
          this.websock.close()
        }
      },
      initWebSocket() {
        //初始化weosocket
        this.wsUrl = this.baseWsUrl + $cookies.get('TokenID')
        this.websock = new WebSocket(this.wsUrl)
        this.websock.onmessage = this.websocketonmessage
        this.websock.onopen = this.websocketonopen
        this.websock.onerror = this.websocketonerror
        this.websock.onclose = this.websocketclose
      },
      websocketonopen() {
        //连接建立之后执行send方法发送数据
        let actions = {
          ping: 'ping'
        }
        this.websocketsend(JSON.stringify(actions))
      },
      websocketonerror() {
        // 没连接上会一直重连，设置延迟避免请求过多
        if (this.ws) {
          const VM = this
          setTimeout(function() {
            //连接建立失败重连
            VM.initWebSocket()
          }, 1000)
        }
      },
      websocketonmessage(e) {
        getCouponQr({
          id: this.couponID
        }).then(res => {
          if (res.status === 0) {
            this.surplusmoney = res.result.surplusmoney
            QRCode.toCanvas(
              document.getElementById('QRdiv'),
              location.origin + '/j/api/QRcode/QRjump?bid=' + res.result.bid,
              error => {
                if (error) {
                  this.$message.error('二维码加载出错！' + error)
                }
              }
            )
          } else {
            this.$message.error(res.message)
          }
        })
        this.$refs.table.refresh(true)
      },
      websocketsend(Data) {
        //数据发送
        this.websock.send(Data)
      },
      websocketclose(e) {
        //关闭
        console.log('断开连接', e)
        if (this.ws) {
          const VM = this
          setTimeout(function() {
            //连接建立失败重连
            VM.initWebSocket()
          }, 1000)
        }
      }
    }
  }
</script>
